import {BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {TarifaOpcion} from "./tarifa-opcion.model";
import {TarifaTipoMaterial} from "./tarifa-tipo-material.model";
import {BaseEntity} from "../base-entity.model";


export abstract class Tarifa extends BaseEntity {

    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer()
    })
    private _id: number;

    @BasicProperty({
        name: 'Importe Unitario',
        type: PropertyType.Financial(2, 0, 1000),
        sortable: true
    })
    private _importeUnitario: number;

    @BasicProperty({
        name: 'Vigente',
        type: PropertyType.Boolean()
    })
    private _vigente: boolean = true;

    @BasicProperty({
        name: 'Visible para el Cliente',
        type: PropertyType.Boolean(),
    })
    private _publico: boolean = true;

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get importeUnitario(): number {
        return this._importeUnitario;
    }

    set importeUnitario(value: number) {
        this._importeUnitario = value;
    }

    get vigente(): boolean {
        return this._vigente;
    }

    set vigente(value: boolean) {
        this._vigente = value;
    }

    get publico(): boolean {
        return this._publico;
    }

    set publico(value: boolean) {
        this._publico = value;
    }
}
